export const setAllDropDownFieldForBusinessActivity = (dropDownName,form,apiResponse) => {
    const filterDropDownList = (dropdownName) => {
        return apiResponse.reduce((acc, item) => {
            if (item.dropdownName === dropdownName) {
                acc.push({
                    value: item.id,
                    label: item.name,
                });
            }
            return acc;
        }, []);
    }
    const dropdownLists = {"productsandServicesOfferedbyOrganisation": filterDropDownList(dropDownName),};
    const formFields = [...form.formFields];
    formFields.forEach(field => {
        const dropdownList = dropdownLists[field?.id];
        if (dropdownList) {
            field.fieldSetting.options = dropdownList;
        }
    });

    return form.formFields.map((field) =>field.id === "productsandServicesOfferedbyOrganisation"? {...field,fieldSetting: { ...field.fieldSetting,  options: [], },validation: [],} : field);
};


 export const filterDropDownList = (dropdownName, apiResponse) => {
  return apiResponse?.reduce((acc, item) => {
    if (item.dropdownName === dropdownName) {
      acc.push({
        value: item.id,
        label: item.name
      });
    }
    return acc;
  }, []);
};